import { render, staticRenderFns } from "./ContractFormLearningResourceTable.vue?vue&type=template&id=52db1868&"
import script from "./ContractFormLearningResourceTable.vue?vue&type=script&lang=ts&"
export * from "./ContractFormLearningResourceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports